import { getContext } from '@fiverr-private/fiverr_context';
import { count, getUserType } from './utils';

import { CACHE_KEY, CACHE_LIFETIME, STATUS_FETCH } from './constants';

export interface CachedState {
    createdAt?: Date;
    userId?: number;
    tags?: string[];
}

export const getOrInitCachedState = (): CachedState => {
    const cachedState = getCachedState();
    const isExpired = checkIfExpired(cachedState);

    if (isExpired) {
        return cacheState();
    }

    return cachedState;
};

export function getCachedState() {
    const cachedStateStringified = window.localStorage.getItem(CACHE_KEY);

    if (!cachedStateStringified) {
        return undefined;
    }

    try {
        return JSON.parse(cachedStateStringified);
    } catch (err) {
        window.localStorage.removeItem(CACHE_KEY);
    }
}

export function setCachedState(state: CachedState) {
    const { userId } = getContext();
    const stringifiedState = JSON.stringify({
        ...state,
        userId,
        createdAt: state.createdAt || new Date(),
    });
    return window.localStorage.setItem(CACHE_KEY, stringifiedState);
}

export function checkIfExpired(cachedState: CachedState = {}) {
    const { createdAt } = cachedState;
    const { userId } = getContext();

    if (!createdAt || cachedState.userId !== userId) {
        return true;
    }

    const createdAtDate = new Date(createdAt);
    const expirationDate = new Date(createdAtDate.getTime() + CACHE_LIFETIME);
    return new Date() > expirationDate;
}

export const cacheState = (): CachedState => {
    const stateWithUserType = {
        state: 'SHOWN',
        tags: [`user_type-${getUserType()}`],
    };

    setCachedState(stateWithUserType);

    count(STATUS_FETCH.SUCCEEDED);

    return stateWithUserType;
};

export const clearCache = () => window.localStorage.removeItem(CACHE_KEY);
